module.exports = __webpack_public_path__ + "img/doc.ad2652b7.svg";